var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPrevious(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8V16H8H16V8V0H8H0V8ZM1.19431 8V14.8057H8H14.8057V8V1.19431H8H1.19431V8ZM6.98578 6.3128L5.29865 8L6.98578 9.6872C7.91371 10.6152 8.68154 11.3744 8.69206 11.3744C8.7026 11.3744 8.89668 11.1888 9.12334 10.962L9.53545 10.5495L8.56868 9.5829C8.03695 9.05124 7.6019 8.60982 7.6019 8.60197C7.6019 8.5941 8.77488 8.58768 10.2085 8.58768H12.8152V8V7.41232H10.2085C8.77488 7.41232 7.6019 7.4059 7.6019 7.39803C7.6019 7.39018 8.03695 6.94876 8.56868 6.4171L9.53545 5.45046L9.12334 5.03803C8.89668 4.81118 8.7026 4.62559 8.69206 4.62559C8.68154 4.62559 7.91371 5.38483 6.98578 6.3128ZM3.33649 8V11.3365H3.93365H4.53081V8V4.66351H3.93365H3.33649V8Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrevious);
export default __webpack_public_path__ + "static/media/icon--previous.d66e89394745f1d8401ab367f6bdb2c0.svg";
export { ForwardRef as ReactComponent };